// Brand + curated imagery for AVEDEN
export const LOGO =
  "https://customer-assets.emergentagent.com/job_b6a02698-4623-496a-a43b-b4e6241a5dfb/artifacts/cgvq9km1_9C4B7838-C536-4FD2-85F0-3381375EFBC5.png";

export const IMAGES = {
  heroOffice:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/d8136a27ef591a588deb5b9826bf257c3a3d16b1ac2e380de09a518b1d9d830f.png",
  coastline:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/46cae451faa9090b08a8e5edf272f70d5882825c3aeaa281a81ff7da46dbd83e.png",
  interior:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/8379905f9db6a511208ec96aaead4c390714079b1916fdd8065aa6bfd42b07fa.png",
  realAssets:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/5ac7dd7a6776bd74bd9c8ef617fd22fe79f46473ec05053492f3a5e7674bc7b7.png",
  businesses:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/89dd726d87f5104617ea9eddf64b315ad21c49defab52decfc3157d959c4421e.png",
  markets:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/ea57197b4b74a6e011d5367db0ef2861e90e01ec0a6e7b98172cfa7185c40c32.png",
  opportunities:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/f21cf09e06400021f32621d7506a8c2c7b1ce3740b155d62fa506713604c0c88.png",
  portfolioHero:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/5e8a3b9aae3c54af6def3c8c3e2f4428aeb6d91bfa476b80351b6fd45d6c4783.png",
  wellnuss:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/d4e4710d396d4b044e165b02fb59978eb0dc885ffc5cccb8f1f03b4c22da0752.png",
  serviceDealer:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/a2c646d65a338edf37c82a48d96e6af6041a5473e3af1a222d538d71ecbe649c.png",
  waterDealer:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/29f4d586c9a207d1b61949533c258a9f0460ea6615dcb6a1c77963242de06aea.png",
  stage3:
    "https://static.prod-images.emergentagent.com/jobs/b6a02698-4623-496a-a43b-b4e6241a5dfb/images/c5f2672ecd96d1303f1a1cccb2b08140a0a3f57d7ef9af7b6dda3e492dbc82a9.png",
};

export const CONTACT = {
  email: "inquiry@aveden.com",
  phone: "(858) 215-4121",
  phoneHref: "+18582154121",
  address: ["AVEDEN", "1084 N. El Camino Real", "Suite B-337", "Encinitas, CA 92024"],
};

export const NAV_LINKS = [
  {
    label: "Philosophy",
    to: "/philosophy",
    children: [
      { label: "Principles", to: "/principles" },
      { label: "Investments", to: "/investments" },
    ],
  },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Family Office", to: "/family-office" },
  { label: "Contact", to: "/contact" },
];

export const FOOTER_LINKS = [
  { label: "Philosophy", to: "/philosophy" },
  { label: "Principles", to: "/principles" },
  { label: "Investments", to: "/investments" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Family Office", to: "/family-office" },
  { label: "Contact", to: "/contact" },
];
